import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MdSearch } from "react-icons/md";

const roleBadge = (role) => {
  const map = {
    superadmin: "bg-purple-50 text-purple-600",
    admin: "bg-blue-50 text-blue-600",
    user: "bg-green-50 text-green-700",
  };
  return map[role] || "bg-gray-50 text-gray-600";
};

function TableUser() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const role = localStorage.getItem("role");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("/api_w/users", {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        setUsers(response.data.data);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const filteredUsers = users.filter(
    (u) => !searchQuery ||
      u.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      u.username?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      u.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) return (
    <div className="p-8 text-center">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
    </div>
  );

  return (
    <div>
      <div className="flex items-center justify-between gap-4 border-b border-gray-100 px-5 py-4">
        <div className="relative flex-1 max-w-xs">
          <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text" placeholder="Cari nama, username, atau email..."
            value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 pl-9 pr-3 py-2 text-sm text-gray-700 outline-none focus:border-brand-500"
          />
        </div>
        <span className="text-sm text-gray-400">{filteredUsers.length} pengguna</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50">
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">No</th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">Pengguna</th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">Username / Email</th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">Telepon</th>
              <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400">Role</th>
              {role === "superadmin" && (
                <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-gray-400 text-center">Aksi</th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {filteredUsers.length === 0 ? (
              <tr><td colSpan={role === "superadmin" ? 6 : 5} className="py-12 text-center text-sm text-gray-400">Tidak ada pengguna ditemukan</td></tr>
            ) : filteredUsers.map((item, index) => (
              <tr key={item.id} className="hover:bg-gray-50/80 transition-colors">
                <td className="px-5 py-4 text-sm text-gray-500">{index + 1}</td>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    <img alt="" src={item.profile_pict || ""} className="h-9 w-9 rounded-full object-cover bg-gray-100" onError={(e) => { e.target.style.display="none"; }} />
                    <span className="text-sm font-semibold text-navy-700">{item.name}</span>
                  </div>
                </td>
                <td className="px-5 py-4">
                  <p className="text-sm text-gray-700">{item.username}</p>
                  <p className="text-xs text-gray-400">{item.email}</p>
                </td>
                <td className="px-5 py-4 text-sm text-gray-500">{item.phone || "—"}</td>
                <td className="px-5 py-4">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${roleBadge(item.role)}`}>
                    {item.role}
                  </span>
                </td>
                {role === "superadmin" && (
                  <td className="px-5 py-4">
                    <div className="flex justify-center">
                      <button
                        onClick={() => navigate(`/admin/edit-user/${item.id}`)}
                        className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50 text-blue-500 hover:bg-blue-100 transition-colors"
                      >
                        <FaEdit className="h-3.5 w-3.5" />
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableUser;
